/* assets/bee_scorer_logic.js
 * Rally-scoring rules for the scoring page (templates/page.scoring.liquid).
 * Pure functions, no DOM, so tests/scorer_logic.test.js can run them in Node.
 *
 * Rules (2026 rules sheet): one game to 21, win by 1, a point on every rally.
 * Freeze: a team at 20 can only win the last point on its own serve. If it
 * wins a rally while receiving, it gets the serve back but no point.
 * The numbers come from RULES in apps_script/scoring.gs, so the page and the
 * sheet check games the same way.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.BeeScorerLogic = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  var DEFAULT_RULES = { target: 21, winBy: 1, freeze: 20, timeouts: 1, timeoutSeconds: 60 };

  function withDefaults(rules) {
    var r = {};
    for (var k in DEFAULT_RULES) r[k] = rules && rules[k] != null ? rules[k] : DEFAULT_RULES[k];
    if (rules && rules.freeze === null) r.freeze = null; // null turns the freeze off
    return r;
  }

  // pos[t] = [player on the RIGHT, player on the LEFT] for team t (0 or 1).
  function newGame(firstServer, pos, rules) {
    var r = withDefaults(rules);
    return {
      score: [0, 0],
      server: firstServer,
      pos: [pos[0].slice(), pos[1].slice()],
      timeoutsLeft: [r.timeouts, r.timeouts],
      rules: r,
    };
  }

  function clone(s) {
    return JSON.parse(JSON.stringify(s));
  }

  function winner(s) {
    var r = s.rules;
    for (var t = 0; t < 2; t++) {
      if (s.score[t] >= r.target && s.score[t] - s.score[1 - t] >= r.winBy) return t;
    }
    return -1;
  }

  function isFrozen(s, t) {
    return s.rules.freeze != null && s.score[t] >= s.rules.freeze;
  }

  // Team w won the rally. Returns { state, outcome } and leaves s untouched.
  // outcome: 'point' (server scored), 'sideout' (receiver scored and serves),
  // 'frozen' (receiver at the freeze: serve changes, no point), 'over'.
  function rally(s, w) {
    if (winner(s) >= 0) return { state: s, outcome: 'over' };
    var n = clone(s);
    var outcome;
    if (w === n.server) {
      n.score[w]++;
      outcome = 'point';
    } else if (isFrozen(n, w)) {
      n.server = w;
      outcome = 'frozen';
    } else {
      n.score[w]++;
      n.server = w;
      outcome = 'sideout';
    }
    return { state: n, outcome: outcome };
  }

  // Even score serves from the right, odd from the left. Players keep their
  // side all game, so the side also tells us who serves.
  function serverInfo(s) {
    var t = s.server;
    var even = s.score[t] % 2 === 0;
    return { team: t, side: even ? 'RIGHT' : 'LEFT', player: s.pos[t][even ? 0 : 1] };
  }

  // The score the server calls: serving team first.
  function call(s) {
    return [s.score[s.server], s.score[1 - s.server]];
  }

  // Could a game really end at a-b under these rules?
  // Win by 1: the winner has exactly the target and the loser less.
  // Win by 2 or more: past the target only a lead of exactly winBy is possible.
  function validFinal(a, b, rules) {
    var r = withDefaults(rules);
    if (!(Number.isInteger(a) && Number.isInteger(b)) || a < 0 || b < 0) return false;
    var w = Math.max(a, b), l = Math.min(a, b);
    if (w < r.target || w - l < r.winBy) return false;
    return w === r.target || (r.winBy >= 2 && w - l === r.winBy);
  }

  return {
    DEFAULT_RULES: DEFAULT_RULES,
    withDefaults: withDefaults,
    newGame: newGame,
    rally: rally,
    winner: winner,
    isFrozen: isFrozen,
    serverInfo: serverInfo,
    call: call,
    validFinal: validFinal,
    clone: clone,
  };
});
